<template>

<div class="full-width">
    <div transition="fade-transition" class="pa-3" v-if="visible">


        <div class="full-width white-background mb-4 pa-2 rounded elevation-2" style="text-align:center;">
        
            <v-btn @click="dismiss" color="red" icon text style="float:right;margin-top:-5px;margin-right:-5px">
                <v-icon >cancel</v-icon>
            </v-btn>
        
            <InterfaceField :field="announcementField" :record="announcementRecord" />
            <v-btn @click="dismiss" style="margin:auto;" color="primary">{{buttonText}}</v-btn>
    
        </div>
    </div>
</div>
</template>

<script>

const ANNOUNCEMENT_NUMBER = 9
const BUTTON_TEXT = "Love It"

import DataHelpers from '../helpers/DataHelpers'
import InterfaceField from '../builder/InterfaceField'


export default {
    
    data() {
        return {
            visible: false,
        }
    },

    components: {
        InterfaceField,
    },
    
    props: {
        item: Object,
    },

    computed: {
        buttonText () {
            return BUTTON_TEXT
        },
        announcementField() {
            return {name: 'announcement', type:'Embed', disabled: true }
        },
        announcementRecord() {
            return {
                announcement: 'https://docs.google.com/document/d/e/2PACX-1vTnYt3aI8BKbFsTx5lQK4xyLxCnqURErNDJnHnX813xS9Y1FFO6H1wrJQUYjMN4SMTlEixljMC_xk69/pub?embedded=true'
            }
        }
    },

    methods: {
        dismiss() {
            localStorage.setItem('announcementNumber', ANNOUNCEMENT_NUMBER)
            this.visible = false
        },
    },

    created() {
        let announcementNumber = localStorage.getItem('announcementNumber') || 0
        if(announcementNumber < ANNOUNCEMENT_NUMBER)
            this.visible = true
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// Announcements.vue?dd02efda